export function h3d(ctx) {
    return {
        styles: {
            main: {
                bg_color: `${ctx.SCR}ff`,
                border_color: `${ctx.BORDER}ff`,
                border_width: 2,
                outline_color: `${ctx.primary}ff`,
                shadow_color: '#00000033',
                radius: 5,
            },
        },
    };
}
